import { Navigate, useRoutes, useSearchParams } from 'react-router-dom';
// import PrivateRoute from './private.route';

// pages
// import HomePage from '../pages/home/home';

// import LoginPage from '../pages/auth/login';
// import RegisterPage from '../pages/auth/';
// import ForgotPasswordPage from '../pages/auth/forgotPassword';
// import PasswordResetMailSuccess from '../pages/auth/passwordResetMailSuccess';
// import Page404 from '../';


// import Dashboard from '../pages/home/dashboard';
// import AppLayout from '../pages/home/dashboard';
// import Users from '../pages/home/dashboard';
import AdminUsersList from '../features/providerPortal/AdminUsers/admin-users-list';
import IntentsList from '../features/providerPortal/Intents/intent-list';
import MyPortal from '../pages/myPortal';
import MyMessagesList from '../pages/messages/list';
import LoginPage from '../pages/auth/login';
import RegisterPage from '../pages/auth/register';
import RegisterDetailsPage from '../pages/auth/register-details';
import Page404 from '../pages/Page404';
import MyProfile from '../pages/profile/profile';
import PrivateRoute from './private.route';
import AIModuleList from '../features/providerPortal/aiDevelopment/modules-list';
import AIAddEditModule from '../features/providerPortal/aiDevelopment/add-edit-module';
import AIViewModule from '../features/providerPortal/aiDevelopment/view-module';
import ServiceTicketList from '../features/providerPortal/serviceTickets/ticket-list';
import ViewServiceTicket from '../features/providerPortal/serviceTickets/view-ticket';
import MultiFromPage from '../features/providerPortal/aiDevelopment/multiFromPage';
import DashboardPage from '../features/providerPortal/dashboard';

// Redirect /:facility/ai-development -> /:facility/ai-development/modules (preserves query, e.g. gmail=error)
function AIDevelopmentRedirect() {
  const [searchParams] = useSearchParams();
  return <Navigate to={{ pathname: 'modules', search: searchParams.toString() }} replace />;
}

// ----------------------------------------------------------------------

export default function Router() {
  const routes = [
    {
      path: '/',
      element: <h1>Welcome</h1>,
    },
    {
      path: '/register',
      element: <RegisterPage />,
    },
    {
      path: '/register/details',
      element: <RegisterDetailsPage />,
    },
    {
      path: '/:facility',
      children: [
        { path: '', element: <PrivateRoute><MyPortal /></PrivateRoute> },
        { path: 'login', element: <LoginPage /> },
        { path: 'register', element: <RegisterPage /> },
        {
          path: 'auth',
          children: [
            { element: <Navigate to="login" />, index: true },
            { path: 'login', element: <LoginPage /> },
            { path: 'register', element: <RegisterPage /> },
          ]
        },
        {
          path: 'my-portal',
          element: <PrivateRoute><MyPortal /></PrivateRoute>
        },

        {
          path: 'inbox',
          element: <PrivateRoute><MyMessagesList /></PrivateRoute>
        },
        {
          path: 'inbox',
          element: <MyMessagesList />,
        },
        {
          path: 'profile',
          element: <MyProfile />,
        },
        {
          path: 'ai-development',
          element: <PrivateRoute><AIDevelopmentRedirect /></PrivateRoute>,
        },
        {
          path: 'ai-development/modules',
          element: <PrivateRoute><AIModuleList /></PrivateRoute>
        },
        {
          path: 'ai-development/new-module',
          element: <PrivateRoute><AIAddEditModule /></PrivateRoute>
        },
        {
          path: 'mul-form',
          element: <PrivateRoute><MultiFromPage /></PrivateRoute>
        },
        {
          path: 'ai-development/edit-module/:id',
          element: <PrivateRoute><AIAddEditModule /></PrivateRoute>
        },
        {
          path: 'ai-development/view-module/:id',
          element: <PrivateRoute><AIViewModule /></PrivateRoute>
        },
        {
          path: 'ai-development/tickets',
          element: <PrivateRoute><ServiceTicketList /></PrivateRoute>
        },
        {
          path: 'ai-development/view-ticket/:id',
          element: <PrivateRoute><ViewServiceTicket /></PrivateRoute>
        },
        {
          path: 'dashboard',
          element: <PrivateRoute><DashboardPage /></PrivateRoute>
        },
        {
          path: 'admin-users',
          element: <PrivateRoute><AdminUsersList /></PrivateRoute>
        },
        {
          path: 'intents',
          element: <PrivateRoute><IntentsList /></PrivateRoute>
        },
      ]

    },


    {
      path: '404',
      element: <Page404 />,
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ];

  const privateRoutes = [];

  return useRoutes(routes.concat(privateRoutes));
}
